import { render, staticRenderFns } from "./salesman_relationship.vue?vue&type=template&id=200f8511&scoped=true"
import script from "./salesman_relationship.vue?vue&type=script&lang=js"
export * from "./salesman_relationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f8511",
  null
  
)

export default component.exports